/**
 * @fileoverview contains a list of URL parameters used in the application, utilities to access them, as well as types and
 * assertions to help ensure they're used safely.
 */

import type { Nominal } from '../type';
import { assert } from '../utils';

export type UrlParam = Nominal<string, 'urlParam'>;

const allParams = new Set<UrlParam>();
function createParam(newParam: string): UrlParam {
  const castedParam = newParam as UrlParam;

  assert(!allParams.has(castedParam), 'Param strings should be unique to prevent bugs');
  allParams.add(castedParam);

  return castedParam;
}

export const FORCE_RECOILIZE_PARAM = createParam('forceRecoilize');
export const RELEASE_NOTES_OPEN_PARAM = createParam('releaseNotes');
